import axios from './../../config/axios';

function search(query) {
    return axios().get("/insurance/companies-search", {
        params: {
            search: query
        }
    })
}

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;
    return axios().get("/insurance/companies", { params })
}

function create(data) {
    return axios().post("/insurance/companies", data)
}

function find(id) {
    return axios().get(`/insurance/companies/${id}`)
}

function update(id, data) {
    return axios().put(`/insurance/companies/${id}`, data);
}

function remove(id) {
    return axios().delete(`/insurance/companies/${id}`);
}

export default {
    search,
    create,
    index,
    find,
    update, 
    remove
}